const emailChecker = RegExp(
  /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
);

let decCheck = "^100(\.0{1,2})?$"


// const textChecker = RegExp(
//   /^(?:[A-Za-z _.]+[0-9 _.]|[0-9 _.]+[A-Za-z _.])[A-Za-z0-9 + _.]*|[A-Za-z _.]+$/
// );

// const textingChecker = /^[a-eA-E]{1}[+-%]?/gm

// const versionChecker = RegExp(/^([A-Za-z0-9])|([0-9]\.[0-9])+$/);

// const numChecker = RegExp(/^([0-9])|([0-9]\.[0-9])+$/);

const numberChecker = RegExp(/^[0-9]+$/);
let whiteSpaceCheck = "/\s/g"

const passChecker = RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
);

export let errors = {};

export let valid = false;

/**
 * refresh function reset all the error messages.
 */
export const refresh = () => {
  errors = {};
};

/**
 * validator function to check the validation for form input values based on the onchage function.
 */
export const Validator = ({ name, value, type, required, max, min }) => {
  errors[name] = "";
  if (required) {
    errors[name] = value.length > 0 ? false : "This field is mandatory";
   }
   else if (!required){
    errors[name] = ""
   }

 
    // if (type == "date") {
    //   errors[name] =
    //     value.length > 0 || !required ? (
    //       false
    //     ) : (
    //       <span style={{ color: "red" }}>This field is mandatory</span>
    //     );
    // }
  

  switch (type) {
    case "text":
      errors[name] = value.match(/^[a-zA-Z]*$/)
        ? value.length > 0 || !required
          ? false
          : "This field is mandatory"
        : "Enter alphabets only";

      // ? value.match(/[A-Ea-e][+-]?|P|F/gm)
      //     ? max && value.length > Number(max)
      //       ? `The maximum length is ${max} characters`
      //       : min && value.length > Number(min)
      //       ? `The  length is ${min} characters`
      //       : false
      //     : "Use only alphabets(A TO E)"
      //   : errors[name];

      break;
    case "number":
      console.log("value.match('^[0-9]+$')",value.match('^[0-9]+$'));
     console.log("value");
      errors[name] =
        value.length >= 1
          ? value.match('^[0-9]+$') || value.match(/^\d{0,3}\.\d{0,2}$/)
            ? false
            : "Enter number only"
          : "This field is mandatory";

      // value.length
      //   ? numberChecker.test(value)
      //     ? max && value.length > Number(max)
      //       ? `The maximum length is ${max} `
      //       : false
      //     : false
      //   : errors[name];

      break;
    case "decimal":
      errors[name] = value.length
        ? decCheck.test(value)
          ? max && value.length > Number(max)
            ? `The maximum length is ${max} `
            : false
          : false
        : errors[name];
      switch (name) {
        case "esiNo":
          errors[name] =
            value.length === 17 ? false : "ESI Number must be 17 numbers";
          break;
        case "uanNo":
          errors[name] =
            value.length === 12 ? false : "UAN Number must be 12 numbers";
          break;
        case "aadharNo":
          errors[name] =
            value.length === 12 ? false : "Aadhar Number must be 12 numbers";
          break;
        case "socialSecurity":
          errors[name] =
            value.length === 9
              ? false
              : "SocialSecurity Number must be 9 numbers";
          break;
        default:
          errors[name] = errors[name];
      }
      break;
    case "tel":
      errors[name] = value.length
        ? value.length === 10
          ? numberChecker.test(value)
            ? false
            : "Enter numbers only"
          : "Mobile number must be 10 numbers"
        : errors[name];
      break;
    case "email":
      errors[name] = value.length
        ? emailChecker.test(value)
          ? false
          : "Email is not valid"
        : errors[name];
      break;
    case "textarea":
      errors[name] =
      value.trim().length === 0 && required  ? "This field is mandatory":
        value.length == 1
          ? value.length === 1 && name !== "noOfYears"
            ? "It should have more than one character"
            : false
          : value.length > 1
          ? value.match(/^[a-zA-Z\w\s\.\/\-\,\'"]*$/gm)
            ? false
            : "Use only alphabets, numbers with alphabets with spaces"
          : errors[name];

      // errors["single"] = value.length === 1 ? "it should have more than one charector":false
      break;
    case "date":
      errors[name] = value ? errors[name] : "Date is mandatory";
      break;
    case "time":
      errors[name] = errors[name].length > 0 ? errors[name] : false;
      break;
    case "select-one":
      errors[name] = errors[name].length > 0 ? errors[name] : false;
      break;
    case "password":
      errors[name] =
        value.length && name !== "signInPassword"
          ? passChecker.test(value)
            ? false
            : "Password length atleast 8 characters (1 lowerCase, 1 upperCase, 1 number, 1 special character)"
          : errors[name];
      break;
    case "file":
      errors[name] = errors[name].length > 0 ? errors[name] : false;
      break;
    default:
      errors[name] = false;
  }

  return errors;
};

/**
 * submitValidator function to varify the form inputs when user submit the form.
 */
export const submitValidator = (data) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].type !== "submit") {
      Validator(data[i]);

      let ob = Object.values(errors).filter((item) => item !== false).filter((value) => value !== "");;
      if (ob.length > 0) {
        if (
          (ob[0] === "" && ob.length === 1) ||
          (ob[0] === "" && ob.length === 2)
        ) {
          valid = true;
        } else {
          valid = false;
        }
      } else {
        valid = true;
      }
    }
  }
  return valid;
};
